import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/home/home';
import Help from './pages/help/help';
import Page404 from './pages/404/404';
import EZQuote from './components/ez-quote/ez-quote';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/home' element={<Home></Home>}></Route>
        <Route path='/ezquote' element={<EZQuote></EZQuote>}></Route>
        <Route path='/help' element={<Help></Help>}></Route>
        <Route path='/*' element={<Page404 />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
